/*import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class SimpleMap extends Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 11
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100vh', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyBUQ2ZxUVXcm-XZ6CTWx3s9l6fnLVtj6MA' }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={59.955413}
            lng={30.337844}
            text="My Marker"
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;*/
/*
import React from "react";
import ReactDOM from "react-dom";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const MyMapComponent = compose(
  withProps({
 
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyChT7iBjqvTKOK4VdtaOa9nZiSqNk38z_I",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap defaultZoom={8} defaultCenter={{ lat:  9.945923199999999297915564966388046741485595703125, lng: -84.07097210000000586660462431609630584716796875 }}>
    {props.isMarkerShown && (
      <Marker position={{ lat: -34.397, lng: 150.644 }} />
    )}
  </GoogleMap>
));

export default MyMapComponent;
*/
import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker,InfoWindow} from "react-google-maps"

const MyMapComponent = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAwG2nsa5s_tm_2NmF07zGzRnZlRWNjYNo",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat:props.longitude, lng: props.latitude }}
  >
    {props.isMarkerShown && <Marker position={{ lat:props.longitude , lng: props.latitude }} onClick={props.onMarkerClick} >

<InfoWindow
key={`infowindow`}
visible={true}>
<div>{props.address_description}</div>
</InfoWindow>
</Marker>
    
    
    
    
    
    
    }
  </GoogleMap>
)

class MyFancyComponent extends React.PureComponent {
  
constructor(props) {
  super(props);
  this.state = {
    latitude:this.props.latitude,
    longitude:this.props.longitude,
    address_description:this.props.address_description,
    isMarkerShown: false,

  }
}
  

  componentDidMount() {
    this.delayedShowMarker()
    console.log(this.props.latitude)
    console.log(this.props.longitude)
    console.log(this.props.address_description)
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true })
    }, 3000)
  }

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false })
    this.delayedShowMarker()
  }

  render() {
    return (
      <MyMapComponent 
        latitude={this.props.latitude}
        longitude={this.props.longitude}
        address_description={this.props.address_description}
        isMarkerShown={this.state.isMarkerShown}
        onMarkerClick={this.handleMarkerClick}
      />
    )
  }
}

export default MyFancyComponent


// WEBPACK FOOTER //
// ./src/routes/main/Orders/Map.js